import {computed, ref} from "vue";
import {TreatmentSheet} from "@/medication-checkup/services/TreatmentSheets";

/**
 * Which of several prescriptions is shown, and the way from one to the next.
 */
export const useSheetCursor = (sheets: () => TreatmentSheet[], start = 0) => {
    const index = ref(start);

    const sheet = computed<TreatmentSheet | null>(() => sheets()[index.value] ?? null);

    const go = (direction: 1 | -1) => {
        const next = index.value + direction;

        if (next >= 0 && next < sheets().length) {
            index.value = next;
        }
    };

    return {index, sheet, go};
};
